import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SpinInputClass;
function SpinInput() {
  if (SpinInputClass === VOID) {
    class $ {
      constructor(partyId, playerIds, pinIds) {
        this.z6o_1 = partyId;
        this.a6p_1 = playerIds;
        this.b6p_1 = pinIds;
      }
      toString() {
        return 'SpinInput(partyId=' + this.z6o_1.toString() + ', playerIds=' + toString(this.a6p_1) + ', pinIds=' + toString(this.b6p_1) + ')';
      }
      hashCode() {
        var result = this.z6o_1.hashCode();
        result = imul(result, 31) + hashCode(this.a6p_1) | 0;
        result = imul(result, 31) + hashCode(this.b6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpinInput()))
          return false;
        if (!this.z6o_1.equals(other.z6o_1))
          return false;
        if (!equals(this.a6p_1, other.a6p_1))
          return false;
        if (!equals(this.b6p_1, other.b6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpinInput');
    SpinInputClass = $;
  }
  return SpinInputClass;
}
//region block: exports
export {
  SpinInput as SpinInputg1yg8g6z8wv9,
};
//endregion

//# sourceMappingURL=SpinInput.mjs.map
